import type { JSX } from 'react';

import NextImage, { type ImageProps } from 'next/image';

import { getImageOptimizerSrc, toStorefrontMediaUrl } from '@/lib/media-url';

/**
 * `next/image` for storefront pages. Use this instead of importing
 * `next/image` directly (eslint enforces it).
 *
 * Optimized images keep a bucket `src`, so the optimizer never fetches from
 * its own host and the page only carries `/_next/image?url=...`. An
 * unoptimized image (explicit `unoptimized`, or any SVG) is rendered with its
 * raw `src`, so that one gets the storefront `/media/...` or `/images/...`
 * path instead of the bucket URL.
 */
export default function StorefrontImage(props: ImageProps): JSX.Element {
  const { src, unoptimized } = props;
  if (typeof src !== 'string') return <NextImage {...props} />;

  const routedSrc = unoptimized ? toStorefrontMediaUrl(src) : getImageOptimizerSrc(src);
  return <NextImage {...props} src={routedSrc} />;
}
